module.exports = __webpack_public_path__ + "static/media/ExoBNNVARA-Italic.9d78a449.woff";